import { render } from "./ShopTile.vue?vue&type=template&id=09e46760"
import script from "./ShopTile.vue?vue&type=script&lang=js"
export * from "./ShopTile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marianne/DevProjects/Marinka backup 29-08-2025/full website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__